import { type ErrorInfo, type FC, type ReactNode, useCallback } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

import { useHospitalData } from "../contexts/HospitalDataProvider";
import { trackEvent } from "../utils/analytics";
import axiosInstance from "../utils/networkWrapper";

function useSendErrorLogs() {
	const {
		chosenDepartment: { department_id },
	} = useHospitalData();

	return useCallback(
		async (error: unknown, errorInfo: ErrorInfo) => {
			const message = error instanceof Error ? error.message : String(error);
			const name = error instanceof Error ? error.name : "Unknown";

			trackEvent("Frontend error", {
				message,
				name,
				errorInfo,
			});

			await axiosInstance.post("/fe-logs", { message, name, errorInfo }, { params: { department_id } }).catch(console.error);
		},
		[department_id],
	);
}

export const ErrorBoundary: FC<{
	fallback?: ReactNode;
	children: ReactNode;
}> = ({ fallback = null, children }) => {
	const sendErrorLog = useSendErrorLogs();

	return (
		<ReactErrorBoundary fallback={fallback} onError={sendErrorLog}>
			{children}
		</ReactErrorBoundary>
	);
};
